import { render, staticRenderFns } from "./realTimeMonitoringDetail.vue?vue&type=template&id=8b2f5fac&"
import script from "./realTimeMonitoringDetail.vue?vue&type=script&lang=js&"
export * from "./realTimeMonitoringDetail.vue?vue&type=script&lang=js&"
import style0 from "./realTimeMonitoringDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports